import React from "react";
import styled from "styled-components";

function DateInput({ style, iconStyle, onChange, value, disabled }) {
  return (
    <>
      <div
        style={{
          width: "338px",
          position: "relative",
        }}
      >
        <InputWrapper
          required
          type={"date"}
          data-placeholder={"YYYY/MM/DD"}
          style={{
            ...style,
          }}
          onChange={onChange}
          value={value}
          disabled={disabled}
          $isValue={!isNaN(new Date(value).getTime())}
        />
        <img
          src="/assets/admin/icons/ico_celendar.svg"
          alt=""
          style={{
            position: "absolute",
            right: "15px",
            top: "15px",
            pointerEvents: "none",
            ...iconStyle,
          }}
        />
      </div>
    </>
  );
}

export default DateInput;

const InputWrapper = styled.input.attrs((props) => {})`
  width: 100%;
  height: 48px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 4px;
  background: inherit;
  padding: 13px 15px;
  color: ${(props) =>
    props.$isValue
      ? "rgba(181, 181, 181) !important"
      : "rgba(181, 181, 181, 0.5) !important"};
  font-family: "Pretendard";
  font-weight: 400;
  font-size: 15px;
  line-height: 21.25px;

  &:focus {
    outline: none !important;
    border-color: #27beff !important; /* 우선순위 강제 */
  }

  &::placeholder {
    color: rgba(181, 181, 181, 0.5) !important;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
  }

  &:disabled {
    border-color: #b8bfc4;
    color: #808991 !important;
    background: #80899133 !important;
  }
`;
